import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'material-ui/Toggle';
import styled from 'styled-components';

const StyleInputWrapper = styled.div`
    margin: 1rem 0;
    max-width: 250px;
`;

const RenderBooleanInputField = (props) => {
    const {
        input: {
            onChange,
            value,
        },
        label,
        labelStyle,
        style,
        toggleStyle,
    } = props;

    return (
        <StyleInputWrapper style={ style }>
            <Toggle
                defaultToggled={ !!value }
                onToggle={ onChange }
                labelStyle={ labelStyle }
                style={ toggleStyle }
                label={ label }
            />
        </StyleInputWrapper>
    );
};

RenderBooleanInputField.defaultProps = {
    toggleStyle: {
        marginBottom: 16,
    },
};

RenderBooleanInputField.propTypes = {
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func,
        value: PropTypes.value,
    }).isRequired,
    label: PropTypes.string.isRequired,
    labelStyle: PropTypes.object,
    meta: PropTypes.shape({
        error: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.string,
        ]),
        touched: PropTypes.bool,
    }),
    style: PropTypes.object,
    toggleStyle: PropTypes.object,
};

export default RenderBooleanInputField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderBooleanInputField.js